import { createFileRoute } from "@tanstack/react-router";
import { KnowledgeCompilationRunPage } from "@client/components/kb/knowledge-compilation-run-page";

export const Route = createFileRoute("/_app/kb/$kbId/compilation/runs/$runId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { kbId, runId } = Route.useParams();
  return <KnowledgeCompilationRunPage kbId={kbId} runId={runId} />;
}
